/**
 * Import Dependency
 */
import React, { Component } from 'react'
import { Icon, Button } from 'antd-mobile'
import injectSheet from 'react-jss'
import cx from 'classnames'
import styles from '../../assets/styles/components/Confirmation'
import environment from '../../config'
import * as _ from 'lodash'

/**
 * Import Antd Mobile Design
 */

/**
 * Import Container
 */

/**
 * Declare Variable
 */

/**
 * Component
 */
class Confirmation extends Component {
  componentDidMount = () => {

  }

  handleContinueOrderBtnClick=() => {
    const { user, history } = this.props
    const isWaiter = (user.permissions || []).some(p => p.includes(':waiter'))
    if (isWaiter) {
      history.push('/basket/change_table')
    } else {
      history.replace({
        pathname: '/home',
        state: {
          from: history.location.pathname,
        },
      })
    }
  }

  handleGoToLandingPage = () => {
    window.location.href = environment.landingUrl
  }

  handleGoToHistory = () => {
    const {
      history,
    } = this.props

    history.replace({
      pathname: '/basket/history',
      state: {
        from: history.location.pathname,
      },
    })
  }

  render () {
    const {
      intl,
      classes,
      // location,
      merchant,
      type,
    } = this.props

    // Intl
    const _titleText = intl.formatMessage({ id: 'confirmation.success' })
    const _subTitleText = intl.formatMessage({ id: 'confirmation.success_submit_order' })
    const _subTitleDescriptionText = _.get(merchant, 'setting.hotelMode') ? intl.formatMessage({ id: 'confirmation.success_hotel_description' }) : intl.formatMessage({ id: 'confirmation.success_description' })
    const _continueOrderBtnText = intl.formatMessage({ id: 'confirmation.continue_order' })
    const _viewHistoryBtnText = intl.formatMessage({ id: 'confirmation.view_history' })
    const _goBackBtnText = intl.formatMessage({ id: 'confirmation.go_back' })

    const wrapStyle = cx(classes.wrap)
    const iconStyle = cx(classes.icon)
    const titleStyle = cx(classes.title)
    const subTitleStyle = cx(classes.subTitle)
    const buttonWrapStyle = cx(classes['button-wrap'])

    if (type === 'campaignCCB') {
      return (
        <div className={wrapStyle}>
          <div className={iconStyle}>
            <Icon type='check-circle-o' size='lg' />
          </div>
          <div className={titleStyle}>
            {_titleText}
          </div>
          <div className={subTitleStyle}>
            {_subTitleText}
          </div>
          <div className={subTitleStyle}>
            {_subTitleDescriptionText}
          </div>
          <div className={buttonWrapStyle}>
            <Button
              type='primary'
              size='large'
              onClick={this.handleGoToLandingPage}
            >
              {_goBackBtnText}
            </Button>
          </div>
        </div>
      )
    }

    return (
      <div className={wrapStyle}>
        <div className={iconStyle}>
          <Icon type='check-circle-o' size='lg' />
        </div>
        <div className={titleStyle}>
          {_titleText}
        </div>
        <div className={subTitleStyle}>
          {_subTitleText}
        </div>
        <div className={subTitleStyle}>
          {_subTitleDescriptionText}
        </div>
        <div className={buttonWrapStyle}>
          <Button
            type='primary'
            size='large'
            onClick={this.handleContinueOrderBtnClick}
          >
            {_continueOrderBtnText}
          </Button>
          <Button
            type='secondary'
            size='large'
            onClick={this.handleGoToHistory}
          >
            {_viewHistoryBtnText}
          </Button>
        </div>
      </div>
    )
  }
};

/**
 * Export
 */
export default injectSheet(styles)(Confirmation)



// WEBPACK FOOTER //
// ./src/components/scenes/Confirmation.js